// extracted by mini-css-extract-plugin
module.exports = {"root":"CubePreview-module__root__1s00Q"};